<template>
<div style="height:100%">
    <div id="container"></div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>
<script>
import util from '../../components/util'
export default {
    data () {
        return {
         viewer:null
        }
    },
    mounted () {
         var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
        this.init();
    },
    methods:{
       init () {
        this.viewer=util.getViewer('container',{
            shouldAnimate : true,
            timeline: true, // 时间滚动条控件
            navigationHelpButton: true, // 默认的相机控制提示控件
            animation: true, // 控制场景动画的播放速度控件
        });

        var dataSource = new Cesium.CzmlDataSource();
        this.viewer.dataSources.add(dataSource);
        
       }
    }
}
</script>
<style scoped>
#container {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>